import { i18n } from '../locale'
const _allEnWords = i18n.messages.en.finding_words
const _constWords  = i18n.messages.en.const_words
const _entries =Object.entries(_allEnWords)
const _constEntries = Object.entries(_constWords)
// console.log(_constEntries)
export const findMatchI18n = function (word, type = 'finding'){
    if(typeof word !== 'string'){
        return word
    }
    if(!_allEnWords){
        return 'not found'
    }
    const targetEntries = type === 'finding' ? _entries : _constEntries
    let findResult = targetEntries.find((v,k)=>{
        return v[1] === word || v[1] === word?.toLowerCase()
    })
    if(!findResult) {
        return word
    }
    if (type === 'finding'){
        
        if(i18n.te(`finding_words.${findResult[0]}`)){
            if(word === 'Terminal ileum'){
                console.log('findResult', word,findResult, i18n.t(`finding_words.${findResult[0]}`))
            }
            return i18n.t(`finding_words.${findResult[0]}`)    
        }
    }else if (type === 'const'){
        // console.log('找到findResult[0]',findResult[0])
        if(i18n.te(`const_words.${findResult[0]}`)){
            return i18n.t(`const_words.${findResult[0]}`)    
        }
    }
    return word
}